module.exports = __webpack_public_path__ + "static/img/pic_emoji_04.4922d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/live-player/assets/images/pic_emoji_04.png
// module id = 654
// module chunks = 1